module.exports = __webpack_public_path__ + "img/77.bd648db0.jpg";